'use strict';

angular.module('imagetrend.components')
    .directive('hlpForm', ['Format', function (Format) {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {
                id: '@?',
                classes: '@?',
                submit: '&',
                permission: '@?',
                permissionState: '@?',
                the_form: '=?theForm',
                fbForm: '=?',
                isFb: '=?',
                setValidationMessages: '=?',

                //disabled
                isDisabled: '=?'
            },
            templateUrl: 'templates/form/form.html',
            link: function (scope, elem, attrs, ctrl) {

                if (!attrs.id) { attrs.id = 'the_form' }

            }
        };
    }])
    .directive('accessibleForm', ['Permissions', '$compile', '$rootScope', '$window', '$timeout', function (Permissions, $compile, $rootScope, $window, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs, ctrl, transclude) {

                if (!attrs.permissionState && $rootScope.$state != null && $rootScope.$state.current != null) { attrs.permissionState = $rootScope.$state.current.name; }

                if (attrs.permission != null && attrs.permissionState != null) {
                    Permissions[attrs.permission](attrs.permissionState).then(function (access) {
                        if (!access) {
                            scope.noPermission = true;
                            scope.handleDisabled();
                        }
                    });
                }

                scope.$watch('isDisabled', function (disabled) {
                    if (disabled) {
                        scope.handleDisabled();
                    }
                });

                scope.handleDisabled = function () {
                    scope.handleDisabledTimer = $timeout(scope.handleDisabledTimeout, 0);
                };

                scope.handleDisabledTimeout = function () {
                    if (!(scope.isFb == true || scope.isFb == "true") && elem !== undefined) {
                        scope.buttons = elem[0].querySelector('#buttons');
                        scope.transcludedButtons = elem[0].querySelector('div.button-group');
                        if (scope.buttons != null && scope.transcludedButtons != null) {
                            scope.buttons.appendChild(scope.transcludedButtons);
                        }
                    }
                };

                scope.onSubmit = function () {
                    scope.$broadcast("form:submit");
                    scope.submissionTimer = $timeout(scope.submissionTimeout, 0);
                }

                // set up event handler on the form element
                scope.submitEventHandler = angular.element(elem).on('submit', scope.onSubmit);

                scope.submissionTimeout = function () {
                    // if this is a FB Form, loop through the form and find all invalid answers, and build the error messages with details for each. We have to do it this way so we know details about what page/question the answers are in (instead of using just a list of answers)
                    if (scope.fbForm != null) {
                        scope.setupValidationMessages(scope.fbForm);
                    }
                    if (scope.the_form != null) {
                        if (scope.setValidationMessages == true) {
                            scope.validationMessages = [];
                        }
                        angular.forEach(scope.the_form.$error.required, function(innerForm) {
                            if (innerForm.$invalid) {
                                innerForm.$setDirty();
                                angular.forEach(innerForm.$error.required, function(field) {
                                    if (field != null && field.$invalid) {
                                        field.$setDirty();
                                        if (scope.setValidationMessages == true) {
                                            var message = field.$name;
                                            if (!scope.validationMessages.includes(message)) {
                                                scope.validationMessages.push(message);
                                            }
                                        }
                                    }
                                });
                            }
                        });
                        if (scope.setValidationMessages == true) {
                            scope.the_form.validationMessages = scope.validationMessages;
                        }
                    }

                    if ((scope.fbForm != null && scope.fbForm.validationMessages && scope.fbForm.validationMessages.length > 0) || (scope.setValidationMessages == true && scope.fbForm.validationMessages && scope.the_form.validationMessages.length > 0)) {
                        $window.scrollTo(0, 0);
                    }
                    else {
                        // firstInvalid = elem[0].querySelector('.ng-invalid');
                        scope.firstInvalid = elem[0].querySelector('.ng-invalid');
                        // if we find one, set focus
                        if (scope.firstInvalid) {
                            scope.firstInvalid.focus();
                        }
                        /*if (firstInvalid) {
                            firstInvalid.focus();
                        }*/
                    }
                };

                scope.setupValidationMessages = function (form) {
                    if (form != null) {
                        scope.validationMessages = [];
                        form.pages.forEach(function (page) {
                            page.sections.forEach(function (section) {
                                if (section.has_content !== false) {
                                    section.components.forEach(function (component) {
                                        // service_user_changes components run validation on the group when the modal closes
                                        if (component.groups != null && component.conditions_met !== false && component.has_content !== false && component.data_set_code !== "service_user_changes") {
                                            component.groups.forEach(function (group) {
                                                if (group.questions != null) {
                                                    group.questions.forEach(function (question) {
                                                        if (question.answer != null && question.answer != undefined && question.answer.invalid) {
                                                            var message = {
                                                                question: question,
                                                                section: section,
                                                                page: page
                                                            }
                                                            scope.validationMessages.push(message);
                                                        }
                                                        question.sub_components.forEach(function (subComponent) {
                                                            if (subComponent.groups != null) {
                                                                subComponent.groups.forEach(function (subGroup) {
                                                                    if (subGroup.questions != null) {
                                                                        subGroup.questions.forEach(function (subQuestion) {
                                                                            if (subQuestion.answer != null && subQuestion.answer != undefined && subQuestion.answer.invalid) {
                                                                                var message = {
                                                                                    question: subQuestion,
                                                                                    section: section,
                                                                                    page: page
                                                                                }
                                                                                scope.validationMessages.push(message);
                                                                            }
                                                                        });
                                                                    }
                                                                });
                                                            }
                                                        });
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        });
                        form.validationMessages = scope.validationMessages;
                    }
                }

                if (scope.fbForm != null) {
                    scope.fbForm.setupValidationMessages = scope.setupValidationMessages;
                }

                scope.$on('$destroy', function () {
                    angular.element(elem).off();
                    angular.element(elem).remove();

                    scope.buttons = undefined;
                    scope.transcludedButtons = undefined;
					scope.submitEventHandler = undefined;
                    scope.firstInvalid = undefined;

                    $timeout.cancel(scope.submissionTimer);
                    $timeout.cancel(scope.handleDisabledTimer);

                    if (elem) {
                        angular.element(elem).off('submit', scope.onSubmit);
                        angular.element(elem).off(); // deregister all event handlers
                        angular.element(elem).remove();
                        elem = undefined;
                    }
                });
            }
        };
    }])
;